import React from 'react';
import ReportFrame from '../ReportFrame';

export default class OperationalSubledgerDetail extends React.Component {
  static defaultProps = {};

  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    const reportParams = {};
    return (
      <div className='contentwrapper bg-white'>
        <ReportFrame
          reportName='Operational Subledger Detail'
          reportParams={reportParams}
          id='operationalsubledgerdetail'
          name='operationalsubledgerdetail'
          title='Operational Subledger Detail'
        />
      </div>
    );
  }
}
